<template>
  <div class="notice">
    <BaseHeader></BaseHeader>
    <div class="content" style="margin: 0 auto; width: 1000px; height: 100%">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/notice' }">会议通知</el-breadcrumb-item>
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div v-if="notice.model.IsShowAttachedFile">
        <el-row>
          <el-col :span="5">
            <div class="grid-content bg-purple">
              <div>
                <div>附件下载</div>
                <div v-for="item in notice.model.DownloadAppendixs" v-bind:key="item.Id">
                  <div class="file">
                    <el-link type="primary" :href="item.FilePath">{{
                      item.FileName
                    }}</el-link>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="19">
            <div class="grid-content bg-purple-light">
              <div class="content-notice">
                <iframe style="width: 100%; height: 720px; background-color: white" :src="notice.model.AttachedFilePath"
                  frameborder="0"></iframe>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-else>
        <div>
          <div>附件下载</div>
          <div v-for="item in notice.model.DownloadAppendixs" v-bind:key="item.Id">
            <div class="file">
              <el-link type="primary" :href="item.FilePath">{{
                item.FileName
              }}</el-link>
            </div>
          </div>
        </div>
        <div class="notice-content">
          <div class="title">{{ notice.model.Tilte }}</div>
          <div class="publishTime">发布时间：{{ notice.model.PublishTime }}</div>
          <div class="divider"></div>
          <div class="notice-text" v-html="notice.model.Content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { reactive } from "vue";
import router from "../router/index";
import { GetNotice } from "../http/notice";
import BaseHeader from '../views/base/BaseHeader.vue';
export default {
  name: 'NoticeDetail',
  components: {
    BaseHeader
  },
  setup() {

    let notice = reactive({
      model: {},
    });
    const home = () => {
      router.push("/");
    };

    let model = {}
    GetNotice({ id: router.currentRoute.value.query.id }).then(res => {
      model = res.Model
      if (model != null && model != {}) {
        notice.model = model;
      }
    })
    return {
      notice,
      home,
    };
  },
};
</script>
<style lang='scss' scoped>
.header {
  height: 88px;
}

.logo {
  width: 265.9px;
  height: 48px;
  margin: 0 417.1px 0 0;
  padding: 0 34.2px 0 154.7px;
  background-color: var(--h-0-s-0-l-100);
  margin-top: 19px;
}

.menu {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 88px;
  -webkit-backdrop-filter: blur(32px);
  backdrop-filter: blur(32px);
  background-color: var(--h-0-s-0-l-100);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
}

.item-text {
  width: 100px;
  height: 30px;
  float: right;
  line-height: 40px;
  margin-top: -6px;
  font-size: 14px;
  padding-left: 10px;
}

.item-text:hover {
  color: #409eff;
}

.home-menu {
  height: 88px;
  display: flex;
  align-items: center;
  justify-content: center;

  >div {
    // padding:0 5% 0 5%;
    text-align: center;
    width: 150px;

    a {
      text-decoration: none;
      color: black;
      width: 40px;
    }
  }
}

#btn-login {
  text-align: center;
  width: 122px;
  //margin: 9px 0 7px 58px;
  padding: 7px 17px;
  border: solid 1px white;

  >span {
    width: 28px;
    // height: 18px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: white;
  }
}

.content {
  .breadcrumb {
    margin: 20px 0 20px 0;
  }

  .file {
    padding-top: 10px;
  }

  .content-notice {
    max-width: 900px;

    height: 100%;
  }

  .title {
    font-family: MicrosoftYaHeiUI;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: 0.64px;
    color: #4a4a4a;
    text-align: center;
  }

  .notice-content {
    margin: 0 auto;
    max-width: 800px;
    width: 600px;
  }

  .publishTime {
    text-align: center;
    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.18;
    letter-spacing: normal;
    color: #999;
  }

  .divider {
    width: 100%;
    height: 1px;
    padding: 0.5px 0;
    background-color: #d7d8db;
    margin-top: 5px;
  }
}

.cursor {
  cursor: pointer;
}
</style>